import { updateWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG } from "../../workLog/queries/useQueryWorkLog";
import { QUERY_WORK_LOGS } from "../../workLog/queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../../workLog/queries/useQueryWorkLogsSummary";
import { QUERY_WORK_ITEM } from "../queries/useQueryWorkItem";
import { QUERY_WORK_ITEMS } from "../queries/useQueryWorkItems";

export const useMutationUpdateWorkItem = () =>
  useWSMutation<
    Awaited<ReturnType<typeof updateWorkItem>>,
    WSServiceError,
    {
      workItemId: string;
      request: Parameters<typeof updateWorkItem>[1];
    }
  >(data => updateWorkItem(data.workItemId, data.request), {
    awaitDependencies: (result, variables) => [
      QUERY_WORK_ITEMS,
      QUERY_WORK_LOG,
      QUERY_WORK_LOGS,
      QUERY_WORK_LOGS_SUMMARY,
      [QUERY_WORK_ITEM, variables.workItemId]
    ]
  });
